import './ProcessStatusLoader.css'

const ProcessStatusLoader = () => {
  return (
    <span className="processStatusLoader"></span>
  )
}

export default ProcessStatusLoader
